import _ from 'lodash';
import React, { useState } from 'react';

const RadioOption = ({ className = "", labelClass = "", label, value, name, isChecked, onChange, errors = null, errorName = "", ...props }) => {

    const innerDotClasses = isChecked
        ? "bg-[#202534]" // Dark color when checked
        : "bg-transparent"; // Transparent when unchecked

    const msg = _.get(errors || {}, errorName || name);

    return (
        <div className='font-urbanist'>
            <label
                htmlFor={`${name}-${value}`}
                className={`inline-flex items-center mr-2 cursor-${props?.disabled ? "not-allowed" : "pointer"} py-2 ${className}`}
            >
                {/* 1. The actual radio button, hidden but functional */}
                <input
                    type="radio"
                    id={`${name}-${value}`}
                    name={name}
                    value={value}
                    checked={isChecked}
                    onChange={onChange}
                    className="sr-only outline-none"
                    {...props}
                />

                {/* 2. Custom visual indicator (Outer White Ring) */}
                <div className={`h-5 w-5 rounded-full border border-gray-500 flex items-center justify-center transition-all duration-200 ease-in-out mr-2 ${isChecked ? 'border-white bg-white' : ''
                    }`}>

                    {/* 3. Inner dark circle (Dark Dot) */}
                    <div className={`h-3 w-3 rounded-full transition-colors duration-200 ease-in-out 
                     ${innerDotClasses}`}>
                    </div>
                </div>

                {/* 4. Label text */}
                <span className={`text-md text-gray-400 ${isChecked ? 'text-white' : ''} ${labelClass}`}>
                    {label}
                </span>
            </label>
            {
                !!msg &&
                <div className="text-red-700 text-sm md:text-md mt-2">{msg}</div>
            }
        </div>
    );
};

export { RadioOption };